import { validateEnvConfig } from '@/lib/env';

const result = validateEnvConfig();

/**
 * Renders a clear error message when required environment variables are missing.
 * Wraps children and only renders them when validation passes.
 */
export function EnvValidator({ children }: { children: React.ReactNode }) {
  if (result.success) {
    return <>{children}</>;
  }

  return (
    <div
      role="alert"
      style={{
        maxWidth: 600,
        margin: '4rem auto',
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
      }}
    >
      <h1 style={{ color: '#dc2626', fontSize: '1.25rem', marginTop: 0 }}>
        Environment Configuration Error
      </h1>
      <p>
        The following required environment variables are missing or invalid.
        Check your <code>.env</code> file against <code>.env.example</code>.
      </p>
      <ul style={{ color: '#b91c1c' }}>
        {result.missingVars.map((name) => (
          <li key={name}>
            <code>{name}</code>
          </li>
        ))}
      </ul>
    </div>
  );
}
